import { useEffect, useState } from 'react'

import { useMediaQuery } from './useMediaQuery'

export type ImageInteractionPolicy = {
  /** 使用自定义右键菜单并拦截 contextmenu（仅键鼠主导 UI） */
  hijackContextMenu: boolean
  /**
   * 程序化「长按保存」：易与微信 / 系统「保存图片」冲突；
   * 仅在 {@link hijackContextMenu} 为 true 时开启（主要为桌面触控板边缘场景）。
   */
  syntheticLongPressSave: boolean
  /** 微信内置浏览器（含 PC 微信打开链接） */
  weChatInApp: boolean
  /**
   * 微信 X5/WebView：不渲染自定义「更多」与底部操作表，避免与内置菜单割裂；
   * 时间线等场景让真实 `img` 浮在最上层以触发「识别图中二维码 / 保存图片」等系统能力。
   */
  useEmbeddedNativeImageMenus: boolean
}

/**
 * 图片交互策略：触控 / 微信内尽量交给系统；桌面鼠标使用自定义右键菜单。
 */
export function useImageInteractionPolicy(): ImageInteractionPolicy {
  const finePointerUi = useMediaQuery('(hover: hover) and (pointer: fine)')
  const [weChatInApp, setWeChatInApp] = useState(false)

  useEffect(() => {
    setWeChatInApp(/MicroMessenger/i.test(navigator.userAgent))
  }, [])

  const hijackContextMenu = finePointerUi && !weChatInApp
  const syntheticLongPressSave = hijackContextMenu
  const useEmbeddedNativeImageMenus = weChatInApp

  return {
    hijackContextMenu,
    syntheticLongPressSave,
    weChatInApp,
    useEmbeddedNativeImageMenus,
  }
}
